import { useRef } from "react";
import "../../styles/banner/Banner.css";
import Video from "../../assets/videos/Banner3D.mp4";

const Banner3D = () => {
  const bannerRef = useRef(null);
  const containerRef = useRef(null);


  const handleMouseMove = (e) => {
    const container = containerRef.current;
    const banner = bannerRef.current;
    if (!container || !banner) return;

    const rect = container.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = -(y - centerY) / 50;
    const rotateY = (x - centerX) / 50;

    banner.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
   
  };

  const handleMouseLeave = () => {
    if (bannerRef.current) {
      bannerRef.current.style.transform = "rotateX(0deg) rotateY(0deg)";
    }
    
  };

  return (
    <div
      className="banner-contenedor"
      ref={containerRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <video
        className="banner3d-video-bg show"
        src={Video}
        autoPlay
        loop
        muted
        playsInline
      />
    </div>
  );
};

export default Banner3D;
